import { useState, useEffect, useContext } from 'react'
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import Menu from '../../components/DashboardAdmin/Menu';
import AuthContext from '../../Context/auth';
import axios from 'axios';
import LoadData from '../../components/Global/LoadData';
import GoBack from '../../components/Global/GoBack';
import LangContext from '../../Context/lang';
import Swal from 'sweetalert2'

const VoirDemande = () => {

    const { Auth,setAuth, Permission } = useContext(AuthContext);
    let navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const page = searchParams.get('page') ? searchParams.get('page') : '1';
    const type = searchParams.get('type') ? searchParams.get('type') : '0';


    let { id ,id_panier} = useParams();

    const { Lang, setLang, Panier, Global, validation, dartaksitsim, daridjarPage, BanqueDossier } = useContext(LangContext);


    const [ListVentes, setListVentes] = useState()

    const [PageNumber, setPageNumber] = useState(0)
    const [Loading, setLoading] = useState(false)
    const [CurrentPage, setCurrentPage] = useState(parseInt(page))


    const [ClientPanierList, setClientPanierList] = useState([])
    const [ClientDocuments, setClientDocuments] = useState([])

    const [Status, setStatus] = useState(0)
    const [CurrentStatus, setCurrentStatus] = useState("")
    const [Motif, setMotif] = useState('');
    const [Shortdescription, setShortdescription] = useState('')
    

    useEffect(() => {

        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/client/client_info/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${Auth?.token}`
                    }
                });

                //  {
                //     headers: {
                //         'Authorization': `Bearer ${Auth?.token}`
                //     }
                // }
                
                // if (response['message'] == 'Token invalid') {
                //     setAuth(false);
                //     return navigate('/account')

                // }
                console.log(response);
                setListVentes(response);
                setStatus(response?.etat ? response?.etat : 0);
                setCurrentStatus(response?.etat ? response?.etat : "");
                setMotif(response?.motif_refus ? response?.motif_refus : '');
                setShortdescription(response?.comment_refus || '');
                // setPageNumber(response['AllNumberOfPage'])
                // setCurrentPage(response['currentPage'])

                // if (parseInt(page) !== response['currentPage']) {
                //     setCurrentPage(1)
                //     console.log("hhhhhhhhhhh");
                // }
                // console.log(DarTaksitCat)

            } catch (error) {
                setLoading(false);

                console.error(error.message);
            }
            setLoading(false);
        }

        fetchData();

    }, []);

    useEffect(() => {

        const GetUserProducts = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/client/client_panier/${id_panier}?with_image=true`, {
                    headers: {
                        'Authorization': `Bearer ${Auth?.token}`
                    }
                });
                console.log('hhhhhhhhhhhhh'+ response);

                setClientPanierList(response)
                if (response?.error == false) {



                }

                console.log(response);

            } catch (error) {
            setLoading(false);

                console.error(error.message);
            }
            setLoading(false);
        }
         GetUserProducts();

    }, []);

    useEffect(() => {

        const GetUserDocuments = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/client/client_documents/${id}`, {
                    headers: {
                        'Authorization': `Bearer ${Auth?.token}`
                    }
                });
                console.log(response);

                setClientDocuments(response)
                if (response?.error == false) {



                }

                console.log(response);

            } catch (error) {
            setLoading(false);

                console.error(error.message);
            }
            setLoading(false);
        }
         GetUserDocuments();

    }, []);

    // console.log((!Loading && ListVentes ? 'hhhhhh' : 'ggggggg'));



    useEffect(() => {


        // if (Auth) {
        //   console.log('hi!');

        // }else{
        //   console.log('no!'); 
        //   return navigate("/");
        // }


    }, [Auth])

    const [MenuShow, setMenuShow] = useState(true)

    const [windowSize, setWindowSize] = useState(getWindowSize());

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);

    // console.log(windowSize);

    function onlyNumbers(str) {
        return /^[0-9]+$/.test(str);
    }

    // const [MobileScreen, setMobileScreen] = useState(windowSize.innerWidth > 992 ? false : true)

    const paymenttype = ['CIB','Edahabia','CCP','Espèces'];
    // const paymenttype = [{ id: 0, name: 'CIB' }, { id: 1, name: 'Edahabia' }, { id: 2, name: 'CCP' }, { id: 3, name: 'Espèces' }];

    
    const [Statutdefinancement, setStatutdefinancement] = useState(onlyNumbers(Permission) ? 
    [
        { id: 0, name: 'Non traité' ,color : 'linear-gradient(45deg, rgb(203 183 27), rgb(232 183 54))'}, 
    { id: 1, name: 'Finançable' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 5, name: 'Non finançable' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 2, name: 'Refuser' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 3, name: 'Approver',color : "linear-gradient(45deg, #2ac6d5, #4aff8a)" },
    { id: 6, name: "Complément d'information bancaire" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 7, name: "Traité au niveau de l'agence" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 8, name: "Traité au niveau du service de mobilisation" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
    { id: 4, name: "Rejeter" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 


] 
    : Permission == "MB" ?[ { id: 1, name: 'Accorder' }, { id: 3, name: 'Approver' }] :  
    [ 
        { id: 0, name: 'Non traité' ,color : 'linear-gradient(45deg, rgb(203 183 27), rgb(232 183 54))'}, 
        { id: 1, name: 'Finançable' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 5, name: 'Non finançable' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 2, name: 'Refuser' ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 3, name: 'Approver',color : "linear-gradient(45deg, #2ac6d5, #4aff8a)" },
        { id: 6, name: "Complément d'information bancaire" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 7, name: "Traité au niveau de l'agence" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 8, name: "Traité au niveau du service de mobilisation" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" }, 
        { id: 4, name: "Rejeter" ,color : "linear-gradient(266deg, #f11e1e, #ff6363)" },
    
    ])

    const StatutdefinancementMobilisation = [ { id: 1, name: 'Accorder' },  { id: 3, name: 'Approver' }];

    const MotifList = ["Capacité insuffisante","Non-respect des critères d’éligibilité","Documents incomplets ou manquants","Informations incorrectes ou fausses","Autre" ];
    const [errors, seterrors] = useState({ status: '', Email: '', Adresse: '', Site: '', Facebook: '', Instagram: '', Heurededébut: '', Heuredefin: '' })
    const [err, seterr] = useState([])

    const [Showerrors, setShowerrors] = useState(false)

    function Validate() {


        if (Status == 2 || Status == 4) {

           

            if (Motif === "Autre") {
                
                if (Shortdescription?.toString()?.trim() == '') {
                    seterrors((prev) => ({ ...prev, Shortdescription: 'Veuillez saisir une petite description' }))
                } else {
                    seterrors((prev) => ({ ...prev, Shortdescription: '' }))
                }
            }else{
                if (Shortdescription?.toString()?.trim()?.length > 100000) {
                    seterrors((prev) => ({ ...prev, Shortdescription: 'Max (100000 Mots)' }))
                } else {
                    seterrors((prev) => ({ ...prev, Shortdescription: '' }))
                }
            }

            if (Motif?.toString()?.trim()?.length > 100000 || Motif?.toString()?.trim() == '') {
                seterrors((prev) => ({ ...prev, Motif: 'Veuillez sélectionner le motif' }))
            } else {
                seterrors((prev) => ({ ...prev, Motif: '' }))
            }

        } else {
            seterrors((prev) => ({ ...prev, Shortdescription: '' }));
            seterrors((prev) => ({ ...prev, Motif: '' }));

        }




    }

    useEffect(() => {

        Validate();

    }, [Status, Shortdescription,Motif])

    useEffect(() => {

        if (Showerrors) {
            const matches = document.querySelectorAll(".err-cart-sum");

            for (let index = 0; index < matches.length; index++) {

                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();


                    window.scrollTo(position.left, position.top + window.scrollY - 120);
                    return
                }
                // if (matches[index].textContent.trim() !== '') {

                //     matches[index].scrollIntoView({behavior: "smooth"});
                //     return
                // }              
            }
        }


    }, [Showerrors]);

    function FindActionPerId(action) {

        let action_name = Statutdefinancement?.find(o => o.id == action)
console.log(action_name);

        if (action_name) {
            return action_name;

        } else {
            return 'En attente'
        }


    }
    const UpdateClientEtat = async (event) => {
        event.preventDefault()



        setShowerrors(true)

        if (errors?.status !== '' || errors?.Shortdescription !== '' || errors?.Motif !== ''
        ) {
            const matches = document.querySelectorAll(".err-cart-sum");

            for (let index = 0; index < matches.length; index++) {

                if (matches[index].textContent.trim() !== '') {

                    let position = matches[index].getBoundingClientRect();


                    window.scrollTo(position.left, position.top + window.scrollY - 60);
                    return
                }
                // if (matches[index].textContent.trim() !== '') {

                //     matches[index].scrollIntoView({behavior: "smooth"});
                //     return
                // }              
            }


            // matches[0].scrollIntoView({behavior: "smooth"});
            console.log(matches[0].offsetTop);
            // matches[0].focus();

            console.log(errors);
            return;
        }



       const data = {"status": Status,"motif" : Motif, "motif_comment": Shortdescription }
        // const formData = new FormData();

        // for (const [key, value] of Object.entries(data)) {
        //     formData.append(key, value);
        // }
        // formData.append("image_rapport_1", Image1);
        // formData.append("image_rapport_2", Image2);
        // formData.append("image_rapport_3", Image3);
        // formData.append("image_rapport_4", Image4);

        // // console.log(Status);
        // // return

        // formData.append("status", Status);
        // // formData.append("payment_date", Date);

        // formData.append("motif", Shortdescription);
        // // formData.append("recu_ccp", Image1 || null);

        setLoading(true)


        axios.put(`${process.env.REACT_APP_LOCAL_URL}/client/update_client_etat/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${Auth?.token}`
            }
        })
            .then(function (response) {
                if (response.data['message'] == 'Token invalid') {
                    setAuth(false);
                    return navigate('/login-cpa')

                }
                console.log(response);
                setLoading(false)
                if (response.data['error'] == true) {
                    // console.log(response.data['err']);
                    // setloading(false)

                    if (response.data['errorList'].constructor == Array) {
                        seterr(response.data['errorList'])
                    }



                    Swal.fire({
                        title: 'Problème',
                        type: 'error',
                        text: "Il y a un problème lors de l'ajout de données.",
                        timer: 2000,
                        showConfirmButton: false,
                        icon: 'error',
                        didClose: () => window.scrollTo(0, 0)



                    });

                    // window.scrollTo({
                    //     top: 0,
                    //     behavior: 'smooth',
                    //   })



                }

                if (response.data['error'] == false) {
                    console.log(response.data['err']);
                    setCurrentStatus(Status);
                    Swal.fire({
                        title: 'Succès',
                        type: 'success',
                        text: 'Le statut a été modifié avec succès',
                        timer: 2000,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        icon: 'success',

                    }).then(function () {
                        // window.location.reload();
                        return
                    });
                }



            }).catch(function (error) {
                // setLoading(false)
                console.log(error);
                if (error) {
                    setLoading(false)

                    Swal.fire({
                        title: 'Problème',
                        type: 'error',
                        text: "Il y a un problème lors de l'ajout de données.",
                        timer: 2000,
                        showConfirmButton: false,
                        icon: 'error',

                    });

                }
            });

    }

    async function UpdateClientEtat2(etat) {

        const data = {"status": Status}

        Swal.fire({
            title: etat == 3 ? "Approuver ce client ?" : "Annuler",
            text: etat == 3 ? "Êtes-vous sûr d'approuver ce client ?" : "Êtes-vous sûr d'approuver ce client ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui !',
            cancelButtonText: 'No !',
            showLoaderOnConfirm: true,
            // reverseButtons: true

            preConfirm: async () => {
                try {
                    const { data: response } = await axios.put(`${process.env.REACT_APP_LOCAL_URL}/client/update_client_etat/${id}`, {"status": etat}, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${Auth?.token}`
                        },
                    });
                    console.log(response);
                    if (response['message'] == 'Token invalid') {
                        setAuth(false);
                        return navigate('/account')
                    }

                    if (response['error'] == true) {
                        await Swal.fire(
                            'Problème!',
                            "L'opération ne s'est pas terminée avec succès",
                            'error'
                        );

                    }

                    if (response['error'] == false) {
                        setCurrentStatus(etat);
                        setStatus(etat)
                        // const updatefListVentes = ListVentes.map(obj =>
                        //     obj?.id == id ? { ...obj, action_banque: etat } : obj
                        // );
                        // setListVentes(updatefListVentes);

                        await Swal.fire(
                            etat == 3 ? 'Approuvé' : 'Annulation!',
                            etat == 3 ? 'Ce client a été approuvé' : "L'envoi a été annulé avec succès",
                            'success'
                        );


                    }





                } catch (error) {
                    console.error(error.message);
                }
            },
        })
    }

    return (
        <div className='dashboard'>


            <div className=''>
                <div className=''>

                    <Menu MenuShow={MenuShow} setMenuShow={setMenuShow} />

                </div>
                <div className='page-client pt-lg-5' style={{ marginLeft: windowSize.innerWidth > 992 ? (MenuShow == true ? '328px' : '89px') : '0px' }}>
                    <div className='menu-mobile-section'>
                        <svg onClick={() => setMenuShow((p) => !p)} xmlns="http://www.w3.org/2000/svg" width="22.575" height="22.453" viewBox="0 0 22.575 22.453">
                            <g id="Groupe_429" data-name="Groupe 429" transform="translate(-177.5 120.5)">
                                <line id="Ligne_82" data-name="Ligne 82" x2="22.575" transform="translate(177.5 -119.5)" fill="none" stroke="#fff" stroke-width="2" />
                                <line id="Ligne_83" data-name="Ligne 83" x2="22.575" transform="translate(177.5 -109.273)" fill="none" stroke="#fff" stroke-width="2" />
                                <line id="Ligne_84" data-name="Ligne 84" x2="22.575" transform="translate(177.5 -99.047)" fill="none" stroke="#fff" stroke-width="2" />
                            </g>
                        </svg>
                    </div>
                    <div className='page-title'> Demande Information<span>Diar Dzair</span></div>
                    {/* <GoBack  url={type == 0 ? "/listvendeuradmin" : "/fournisseurs"} /> */}

                    {Loading ? <LoadData /> : ''}

                    {!Loading && ListVentes ?

                        <>
                            <div className="conatiner mt-4 mb-5">
                            {/* <div className='new-admin-btn mb-0' onClick={() => navigate('/addaction/'+id)}> Nouvelle action  </div>
                            <div className='new-admin-btn mt-2 mb-4' onClick={() => navigate('/clientaction/'+id)}> Voir toutes les actions  </div> */}
                             <div className="conatiner mb-5">
                                    <ul className="list-group list-store-admin">
                                        <li className={`list-group-item active gradiant`} aria-current="true">Panier 
                                       
                                            
                                            </li>

                                            <div className='container info-account cart mt-4'>
                                    {
                     ClientPanierList?.length > 0 && ClientPanierList?.map((item, i) => (

                        // <ProductCart item={item} key={item.hash} />

                        <a className="mb-1" target="blank" href={`https://albaraka.diardzair.com.dz/product/${item?.hash}`} >

                        <div key={`SimulationForm${item?.id}`} className='d-flex flew-wrap align-items-center mb-2 mt-1 cart-product-section'>

                          <div className='me-3'>
                            <div className='product-item-img'>
                              {/* <Link to={`/product/${item?.hashAnnonce}`}> */}
                                <img className="cart-img" src={`https://opr.diardzair.com.dz/uploads/img/${item?.id_image_a}.${item?.url}`} />
                              {/* </Link> */}
                            </div>
                          </div>
                          <div className=''>
                            {/* <Link to={`/product/${item?.hashAnnonce}`}> */}
                              <p className='cart-product-name mb-2'>{item?.nom}</p>
                              <p className='cart-product-marque mb-0 pb-0'>Marque : {item?.marque}</p>
                              <p className='cart-product-marque mb-0 pb-0'>Quantité : {item?.qts}</p>
                            <p className='cart-product-marque mb-0 pb-0'>Prix : {item?.montant} DA</p>
                            {/* </Link> */}
                          </div>

                          <div className='col-lg-4 col-md-6 col-sm-5 text-center mt-3 mt-md-0'>
                          </div>


                        </div>
                        {/* <hr style={{background : "black"}} /> */}
                        </a>

                      
                      ))
                    }
                    <h5 className="mb-3 fw-bold"> Total : {ListVentes?.montant} DA</h5>
                    </div>

                                      
                                       
                                    </ul>
                                </div> 
 
                                <ul className="list-group list-store-admin mt-2">
                                    <li className={`list-group-item active gradiant`} aria-current="true">Information Générale</li>
                                    {/* {ListVentes?.id ? <li className="list-group-item"> <b>Id</b> : {ListVentes?.id}</li> : ''}
                                    {ListVentes?.nom || ListVentes?.prenom ? <li className="list-group-item"> <b>Nom et Prénom</b> : {ListVentes?.nom} {ListVentes?.prenom}</li> : ''}
                                    {ListVentes?.civilite ? <li className="list-group-item"><b> Civilité</b> : {ListVentes?.civilite}</li> : ''}
                                    {ListVentes?.mobile ? <li className="list-group-item"><b> Mobile </b> : {ListVentes?.mobile}</li> : ''}
                                    <li className="list-group-item"><b>Mobile Validé </b> : {ListVentes?.mobile_valid == 1 ? 'Oui' : "Non"}</li>
                                    <li className="list-group-item"><b>Abonnement -  Payment Validé </b> : {ListVentes?.payment_valid == 1 ? 'Oui' : "Non"}</li>
                                    {ListVentes?.payment_methode != null ? <li className="list-group-item"><b>Abonnement - Type de paiement </b> : {paymenttype[ListVentes?.payment_methode]}</li> : ""}
                                    <li className="list-group-item"><b>Dossier -  Payment Validé </b> : {ListVentes?.payment_dossier_valid == 1 ? 'Oui' : "Non"}</li>
                                    {ListVentes?.payment_dossier_methode != null ? <li className="list-group-item"><b>Dossier - Type de paiement </b> : {paymenttype[ListVentes?.payment_dossier_methode]}</li> : ""} */}
                                   

                                    {ListVentes?.id && <li className="list-group-item"><b>Id </b> : {ListVentes?.id}</li>}
                  {ListVentes?.date_ins && <li className="list-group-item"><b>{(validation['date'][Lang])}</b> : {ListVentes?.date_ins}</li>}
                  {ListVentes?.duree && <li className="list-group-item"><b>{(validation['durée'][Lang])}</b> : {ListVentes?.duree} {(dartaksitsim['Mois'][Lang])}</li>}
                  {ListVentes?.mt_ech && <li className="list-group-item"><b>{(validation['mensualité'][Lang])} </b>: {ListVentes?.mt_ech} {(Global['Dajust'][Lang])}</li>}
                  {ListVentes?.mt_rmb && <li className="list-group-item"><b>{(validation['total_rem'][Lang])}</b> : {ListVentes?.mt_rmb} {(Global['Dajust'][Lang])}</li>}
                  {ListVentes?.civilite && <li className="list-group-item"><b>{(validation['civilité'][Lang])}</b> : {ListVentes?.civilite}</li>}
                  {ListVentes?.nom && <li className="list-group-item"><b>{(validation['Nom'][Lang])}</b> : {ListVentes?.nom}</li>}
                  {ListVentes?.prenom && <li className="list-group-item"><b>{(validation['Prénom'][Lang])}</b> : {ListVentes?.prenom}</li>}
                  {ListVentes?.prenom_pere && <li className="list-group-item"><b>{(validation['Prénompère'][Lang])}</b> :{ListVentes?.prenom_pere}</li>}
                  {ListVentes?.nom_mere && <li className="list-group-item"><b>{(validation['Nommère'][Lang])} </b>: {ListVentes?.nom_mere}</li>}
                  {ListVentes?.prenom_mere && <li className="list-group-item"><b>{(validation['Prenommère'][Lang])}</b> : {ListVentes?.prenom_mere}</li>}
                  {ListVentes?.date_naissance && <li className="list-group-item"><b>{(validation['Date_naissance'][Lang])}</b> :  {ListVentes?.date_naissance}</li>}
                  {ListVentes?.wilaya_naissance && <li className="list-group-item"><b>{(validation['Wilaya_naissance'][Lang])}</b> : {ListVentes?.wilaya_naissance}</li>}
                  {ListVentes?.communen && <li className="list-group-item"><b>{(validation['Commune_naissance'][Lang])}</b> :{ListVentes?.communen}</li>}
                  {ListVentes?.num_act_naissance && <li className="list-group-item"><b>{(validation['Num_act_naissance'][Lang])}</b> : {ListVentes?.num_act_naissance}</li>}
                  {ListVentes?.st_familiale && <li className="list-group-item"><b>{(validation['situation_familiale'][Lang])}</b> :  {ListVentes?.st_familiale == "c" && 'Célibataire'} {ListVentes?.st_familiale == 'm' && 'Marié'} {ListVentes?.st_familiale == 'd' && 'Divorcé'} {ListVentes?.st_familiale == 'v' && 'veuf'}</li>}
                  {ListVentes?.niveau && <li className="list-group-item"><b>{(validation['Niveau'][Lang])}</b> : {ListVentes?.niveau == "1" && 'Moins que le niveau secondaire'} {ListVentes?.niveau == '2' && 'Niveau secondaire'} {ListVentes?.niveau == '3' && 'Bachelier'} {ListVentes?.niveau == '4' && 'Universitaire'}</li>}
                  {ListVentes?.nb_enfants >= 0 ? <li className="list-group-item"><b>{(validation['nbrEnfants'][Lang])}</b> : {ListVentes?.nb_enfants}</li> : ''}
                  {ListVentes?.nb_autre >= 0 ? <li className="list-group-item"><b>{(validation['nbrpersonnes'][Lang])}</b> :  {ListVentes?.nb_autre}</li> : ''}

                  {ListVentes?.wilaya && <li className="list-group-item"><b>{(validation['Wilaya'][Lang])}</b> :   {ListVentes?.wilaya}</li>}
                  {ListVentes?.dairas && <li className="list-group-item"><b>{(validation['Daïras'][Lang])}</b> :  {ListVentes?.dairas}</li>}
                  {ListVentes?.commune && <li className="list-group-item"><b>{(validation['Commune'][Lang])}</b> :  {ListVentes?.commune}</li>}
                  {ListVentes?.code_postal && <li className="list-group-item"><b>{(validation['Codepostal'][Lang])}</b> :  {ListVentes?.code_postal}</li>}
                  {ListVentes?.adresse && <li className="list-group-item"><b>{(validation['Adresse'][Lang])}</b> :  {ListVentes?.adresse}</li>}
                  {ListVentes?.mobile && <li className="list-group-item"><b>{(validation['Mobile'][Lang])}</b> :  {ListVentes?.mobile}</li>}
                  {ListVentes?.telephone_professionnel && <li className="list-group-item"><b>{(validation['Mobile2'][Lang])}</b> : {ListVentes?.telephone_professionnel}</li>}
                  {ListVentes?.email && <li className="list-group-item"><b>{(validation['email'][Lang])}</b> :  {ListVentes?.email}</li>}
                  {ListVentes?.piece && <li className="list-group-item"><b>{(validation['piece'][Lang])}</b> :  {ListVentes?.piece}</li>}
                  {ListVentes?.nin && <li className="list-group-item"><b>{(validation['NIN'][Lang])}</b> : {ListVentes?.nin}</li>}
                  {ListVentes?.piece_num && <li className="list-group-item"><b>{(validation['numcn'][Lang])}</b> :  {ListVentes?.piece_num}</li>}
                  {ListVentes?.piece_date && <li className="list-group-item"><b>{(validation['Date_délivrence'][Lang])}</b> :   {ListVentes?.piece_date}</li>}
                  {ListVentes?.piece_par_w && <li className="list-group-item"><b>{(validation['Wilaya_délivrence'][Lang])}</b> :  {ListVentes?.piece_par_w}</li>}
                  {ListVentes?.piece_par && <li className="list-group-item"><b>{(validation['Commune_délivrence'][Lang])}</b> :  {ListVentes?.piece_par}</li>}
                  {ListVentes?.habitation && <li className="list-group-item"><b>{(validation['Habitation'][Lang])}</b> :  {ListVentes?.habitation == "1" && 'Avec les parents'} {ListVentes?.habitation == '2' && 'Locataire'} {ListVentes?.habitation == '3' && 'Propriétaire'} {ListVentes?.habitation == '4' && 'Logt de Fonction'}</li>}



                  
                  {ListVentes?.st_activite && <li className="list-group-item"><b>{(validation['secteuractiv'][Lang])}</b> : {ListVentes?.st_activite == 'i' && 'Indépendant'} {ListVentes?.st_activite == 'p' && 'Public'} {ListVentes?.st_activite == 'v' && 'Privé'} {ListVentes?.st_activite == 'r' && 'Retraité'}</li>}
                  {ListVentes?.profession && <li className="list-group-item"><b>{(validation['Profession'][Lang])}</b> : {ListVentes?.profession} </li>}
                  {ListVentes?.type_contrat && ListVentes?.type_contrat != "0"  ? <li className="list-group-item"><b>{(validation['TypeDeContrat'][Lang])}</b> : {ListVentes?.type_contrat || 'Non'} </li> : ''}
                  {ListVentes?.periode_essai  ? <li className="list-group-item"><b>{(validation?.['période_essai']?.[Lang])}</b> : {ListVentes?.periode_essai} </li> : ''}
                  {ListVentes?.nom_employeur  ? <li className="list-group-item"><b>{(validation?.['nom_emp']?.[Lang])}</b> : {ListVentes?.nom_employeur} </li> : ''}
                  {ListVentes?.wilaya_employeur  ? <li className="list-group-item"><b>{(validation['wilaya_emp'][Lang])}</b> : {ListVentes?.wilaya_employeur} </li> : ''}
                  {ListVentes?.adresse_employeur  ? <li className="list-group-item"><b>{(validation['adresse_emp'][Lang])}</b> : {ListVentes?.adresse_employeur} </li> : ''}

                  




                 

              
                  {ListVentes?.salaire && <li className="list-group-item"><b>{(validation['Salaire'][Lang])}</b> :  {ListVentes?.salaire} {(Global['Da'][Lang])}</li>}
                  {ListVentes?.compte && <li className="list-group-item"><b>{(validation['Compte'][Lang])}</b> : {ListVentes?.compte} </li>}
                  {
                    ListVentes?.compte == "CCP" ?
                    <>
                  
                  {ListVentes?.cpt_ccp && <li className="list-group-item"><b>Numéro de compte CCP</b> : {ListVentes?.cpt_ccp} </li>}
                  {ListVentes?.cle_ccp && <li className="list-group-item"><b>Clé CCP</b> : {ListVentes?.cle_ccp} </li>}
                  </>

                  : ''
                  }

                  {ListVentes?.banque ? <li className="list-group-item"><b>{(validation['bank'][Lang])}</b> :{ListVentes?.banque || 'Non'} </li> : ''}
                  {ListVentes?.autres_revenus ? <li className="list-group-item"><b>Autre Sources De Revenus </b>: {ListVentes?.autres_revenus || 'Non'}</li> : ''}
               

                
                  {ListVentes?.credit_immobilier ? <li className="list-group-item"><b>Crédit Emprunt Immobilier </b>:  {ListVentes?.credit_immobilier}</li> : ''}
                  {
                    ListVentes?.credit_immobilier == "oui" ?
                    <>
                  
                  {ListVentes?.credit_immobilier_mt && <li className="list-group-item"><b>Mensualité du crédit immobilier Da/Mois</b> : {ListVentes?.credit_immobilier_mt} DA</li>}
                  {ListVentes?.credit_immobilier_preteur && <li className="list-group-item"><b>Organisme prêteur immobilier</b> : {ListVentes?.credit_immobilier_preteur} </li>}
                  {ListVentes?.credit_immobilier_datfin && <li className="list-group-item"><b>Date de fin du crédit immobilier</b> : {ListVentes?.credit_immobilier_datfin} </li>}

                  </>

                  : ''
                  }

                  {ListVentes?.credit_voitur ? <li className="list-group-item"><b>Crédit Voiture </b>: {ListVentes?.credit_voitur}</li> : ''}
                  {
                    ListVentes?.credit_voitur == "oui" ?
                    <>
                  
                  {ListVentes?.credit_voitur_mt && <li className="list-group-item"><b>Mensualité du crédit voiture Da/Mois</b> : {ListVentes?.credit_voitur_mt} DA</li>}
                  {ListVentes?.credit_voitur_preteur && <li className="list-group-item"><b>Organisme prêteur de crédit voiture</b> : {ListVentes?.credit_voitur_preteur} </li>}
                  {ListVentes?.credit_voitur_datfin && <li className="list-group-item"><b>Date de fin du crédit voiture</b> : {ListVentes?.credit_voitur_datfin} </li>}

                  </>

                  : ''
                  }

                  
                  {ListVentes?.credit_autre ? <li className="list-group-item"><b>Crédit Autre </b>: {ListVentes?.credit_autre}</li> : ''}
                  {
                    ListVentes?.credit_autre == "oui" ?
                    <>
                  
                  {ListVentes?.credit_autre_mt && <li className="list-group-item"><b>Mensualité de l'autre crédit Da/Mois</b> : {ListVentes?.credit_autre_mt} DA</li>}
                  {ListVentes?.credit_autre_preteur && <li className="list-group-item"><b>Organisme prêteur autre crédit</b> : {ListVentes?.credit_autre_preteur} </li>}
                  {ListVentes?.credit_autre_datfin && <li className="list-group-item"><b>Date de fin de l'autre crédit</b> : {ListVentes?.credit_autre_datfin} </li>}

                  </>

                  : ''
                  }

                  {ListVentes?.credit_loyer ? <li className="list-group-item"><b>Un Loyer À Payer En Cours </b>: {ListVentes?.credit_loyer}</li> : ''}
                  {
                    ListVentes?.credit_loyer == "oui" ?
                    <>
                  {ListVentes?.credit_loyer_mt && <li className="list-group-item"><b>Mensualité de l'autre crédit Da/Mois</b> : {ListVentes?.credit_loyer_mt} DA </li>}
                  </>

                  : ''
                  }

                  {ListVentes?.rloyer ? <li className="list-group-item"><b>Un Loyer À Payer En Cours </b>: {ListVentes?.rloyer}</li> : ''}
                  {
                    ListVentes?.rloyer == "oui" ?
                    <>
                  {ListVentes?.credit_autre_mt && <li className="list-group-item"><b>Loyer</b> : {ListVentes?.credit_autre_mt} DA </li>}
                  </>

                  : ''
                  }
               
                  {ListVentes?.green_card ? <li className="list-group-item"><b>{(validation['green_card'][Lang])} </b>:  {ListVentes?.green_card}</li> : ''}
                  {ListVentes?.sejour_usa ? <li className="list-group-item"><b>{(validation['sejour_usa'][Lang])} </b>:  {ListVentes?.sejour_usa}</li> : ''}

              
                  {ListVentes?.compte_epargne ? <li className="list-group-item"><b>{(validation['charges'][Lang])} </b>:  {ListVentes?.compte_epargne}</li> : ''}
                  {
                    ListVentes?.compte_epargne == "oui" ?
                    <>
                  {ListVentes?.m_compt_epargne && <li className="list-group-item"><b>Compte épargne numéro</b> : {ListVentes?.m_compt_epargne} </li>}
                  </>

                  : ''
                  }


                  {ListVentes?.biens_mt ? <li className="list-group-item"><b>Biens Immeubles Ou Meubles  </b>:  {ListVentes?.biens_mt}</li> : ''}
              


                                    {/* {ListVentes?.wilaya_naissance ? <li className="list-group-item"><b> Wilaya de Naissence </b>: {ListVentes?.wilaya_naissance}</li> : ''}
                            {ListVentes?.commune_naissance ? <li className="list-group-item"><b> Commune de Naissence </b>: {ListVentes?.commune_naissance}</li> : ''}
                            {ListVentes?.wilaya ? <li className="list-group-item"><b> Wilaya </b>: {ListVentes?.wilaya}</li> : ''}
                            {ListVentes?.dairas ? <li className="list-group-item"><b> Daira </b>: {ListVentes?.dairas}</li> : ''}
                            {ListVentes?.commune ? <li className="list-group-item"><b> Commune </b>: {ListVentes?.commune}</li> : ''}
                            {ListVentes?.code_postal ? <li className="list-group-item"><b> Code Postal </b>: {ListVentes?.code_postal}</li> : ''}
                            {ListVentes?.adresse ? <li className="list-group-item"><b> Adresse </b>: {ListVentes?.adresse}</li> : ''}
                            {ListVentes?.nin ? <li className="list-group-item"><b> Numéro d'immatriculation au registre du commerce </b>: {ListVentes?.nin}</li> : ''}
                            {ListVentes?.nrc ? <li className="list-group-item"><b> Centre national du registre de commerce NRC </b>: {ListVentes?.nrc}</li> : ''}
                            {ListVentes?.nif ? <li className="list-group-item"><b> Numéro d'identification fiscale (nif) </b>: {ListVentes?.nif}</li> : ''}
                            {ListVentes?.article_imposition ? <li className="list-group-item"><b> Article d'imposition </b>: {ListVentes?.article_imposition}</li> : ''}
                            {ListVentes?.tva ? <li className="list-group-item"><b> ETES-vous assujetti à la tva ? </b>: {ListVentes?.tva}</li> : ''}
                            {ListVentes?.type_vendeur ? <li className="list-group-item"><b> vous êtes une personne physique ou une entreprise ? </b>: {ListVentes?.type_vendeur}</li> : ''}
                            {ListVentes?.tel ? <li className="list-group-item"><b> Tel </b>: {ListVentes?.tel}</li> : ''}
                            {ListVentes?.secteur_activite ? <li className="list-group-item"><b> Secteur d'activité </b>: {ListVentes?.secteur_activite}</li> : ''}
                            {ListVentes?.nom_boutique ? <li className="list-group-item"><b> Nom de la boutique </b>: {ListVentes?.nom_boutique}</li> : ''}
                            {ListVentes?.type_piece_idnt ? <li className="list-group-item"><b> Type de piéce d'identité </b>: {ListVentes?.type_piece_idnt}</li> : ''}
                            {ListVentes?.piece_idnt ? <li className="list-group-item"><b>Piéce d'identité </b>: <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL}/pdf?test=${ListVentes?.piece_idnt}`}> Voir </a>  </li> : ''}
                            {ListVentes?.rc_file ? <li className="list-group-item"><b>Copie de l'extrait du registre du commerce </b>: <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL}/pdf?test=${ListVentes?.rc_file}`}> Voir </a>  </li> : ''}
                            {ListVentes?.nif_file ? <li className="list-group-item"><b>l'attestation d'immatriculation du NIF </b>: <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL}/pdf?test=${ListVentes?.nif_file}`}> Voir </a>  </li> : ''} */}
                                </ul>
                            </div>
                           
                                <div className="conatiner mb-5">
                                    <ul className="list-group list-store-admin">
                                        <li className={`list-group-item active gradiant`} aria-current="true">Documents 
                                        {/* <a href={`/updatedocuments/${id}`} className='btn-dossier'> <div className='mx-1 d-flex'><div>Modifier</div>
                                                <img className='ms-2' src="https://cdn-icons-png.flaticon.com/512/6747/6747196.png" width={"30"} />

                                            </div></a> */}
                                            
                                            </li>
                                        {/* <li className="list-group-item"><b>Carte d'identité </b> : {ListVentes?.carte_identite ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.carte_identite}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Acte de naissance </b> : {ListVentes?.acte_de_naissance ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.acte_de_naissance}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Justificatif de résidence  </b> : {ListVentes?.fiche_residence ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.fiche_residence}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Fiche Familiale </b> : {ListVentes?.fiche_familiale ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.fiche_familiale}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Extrait de Compte </b> : {ListVentes?.extrait_de_comptes ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.extrait_de_comptes}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Attestation de travail </b> : {ListVentes?.attestation_de_travail ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.attestation_de_travail}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Photo</b> : {ListVentes?.photo ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.photo}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Une copie d’échéancier </b> : {ListVentes?.echeancier ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.echeancier}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Chèque barré</b> : {ListVentes?.cheque_barre ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.cheque_barre}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Fiches de Paie 1</b> : {ListVentes?.fiches_de_paie ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.fiches_de_paie}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Fiches de Paie 2</b> : {ListVentes?.fiches_de_paie_2 ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.fiches_de_paie_2}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                        <li className="list-group-item"><b>Fiches de Paie 3</b> : {ListVentes?.fiches_de_paie_3 ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`${process.env.REACT_APP_LOCAL_URL_Documents}/pdf?test=${ListVentes?.fiches_de_paie_3}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li> */}

                                        {
                      ClientDocuments?.length > 0 ? ClientDocuments?.map((item, i) => (

                        <li className="list-group-item"><b> {item?.nom}</b> : {item?.hash && item?.url ? <a className='vendeur-dossier-voir' style={{ color: "black" }} target="_blank" href={`https://opr.diardzair.com.dz/uploads/ff/${item?.hash}.${item?.url}`}> Voir </a> : "Le fichier n'est pas téléchargé"}</li>
                                           
                      ))

                      : <div className="text-center mt-4 mb-4"> Il n'y a pas encore de documents pour ce client</div>
                    }
                                       
                                    </ul>
                                </div> 

                           
                        </>
                        : ""}
                <div className='container text-center m-auto pt-5'>
                {onlyNumbers(Permission) ? 
                            <div className="col mb-1 mt-1">
                                
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" className='me-3' viewBox="0 0 24 24">
                                    <g id="Union_5" data-name="Union 5" fill="none" stroke-linejoin="round">
                                        <path d="M13.2,24V13.2H24V24ZM0,24V13.2H10.8V24ZM13.2,10.8V0H24V10.8ZM0,10.8V0H10.8V10.8Z" stroke="none" />
                                        <path d="M 22.10000038146973 22.10000038146973 L 22.10000038146973 15.09988975524902 L 15.09988975524902 15.09988975524902 L 15.09988975524902 22.10000038146973 L 22.10000038146973 22.10000038146973 M 8.900110244750977 22.10000038146973 L 8.900110244750977 15.09988975524902 L 1.899999976158142 15.09988975524902 L 1.899999976158142 22.10000038146973 L 8.900110244750977 22.10000038146973 M 22.10000038146973 8.900110244750977 L 22.10000038146973 1.899999976158142 L 15.09988975524902 1.899999976158142 L 15.09988975524902 8.900110244750977 L 22.10000038146973 8.900110244750977 M 8.900110244750977 8.900110244750977 L 8.900110244750977 1.899999976158142 L 1.899999976158142 1.899999976158142 L 1.899999976158142 8.900110244750977 L 8.900110244750977 8.900110244750977 M 24 24 L 13.19989013671875 24 L 13.19989013671875 13.19989013671875 L 24 13.19989013671875 L 24 24 Z M 10.80010986328125 24 L -1.77635683940025e-15 24 L -1.77635683940025e-15 13.19989013671875 L 10.80010986328125 13.19989013671875 L 10.80010986328125 24 Z M 24 10.80010986328125 L 13.19989013671875 10.80010986328125 L 13.19989013671875 -1.77635683940025e-15 L 24 -1.77635683940025e-15 L 24 10.80010986328125 Z M 10.80010986328125 10.80010986328125 L -1.77635683940025e-15 10.80010986328125 L -1.77635683940025e-15 -1.77635683940025e-15 L 10.80010986328125 -1.77635683940025e-15 L 10.80010986328125 10.80010986328125 Z" stroke="none" fill="#6d6d6d" />
                                    </g>
                                </svg>
                                {/* <input type="text" onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g , ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" /> */}
                                <label htmlFor="inputEmail4" className="form-label mb-4">Statut de financement <b className="etat-span"> État actuel : {onlyNumbers(CurrentStatus) ? FindActionPerId(CurrentStatus)?.name : 'Non traité' }</b></label>
                                <div className="container-etat">
                                {Statutdefinancement?.length > 0 && Statutdefinancement?.map((item, i) => (
                                    
                                    <div className={`btn-etat ${Status == item?.id ? "btn-etat-active" : ""}`} style={Status == item?.id ? {background : FindActionPerId(Status)?.color} : {}} onClick={(e) => setStatus(item?.id) }>{item?.name}</div>
                                    ))
                                }
                                </div>

                                {
                                Status == 2 || Status == 4 || Status == 5 ?
                                  <>  <div className="col-md-12 d-flex justify-content-center flex-wrap mt-3">

                            <div className="col-md-6 mb-3 mt-1">
                                {/* <input type="text" onChange={(e) => setActedenaissance(e.target.value.replace(/[^0-9]+/g , ''))} value={Actedenaissance} className="form-control me-2" id="inputPassword4" /> */}
                                <label htmlFor="inputEmail4" className="form-label">Veuillez sélectionner le motif</label>
                                <select class="form-select" aria-label="Default select example" onChange={(e) => setMotif(e.target.value)}>
                                    <option disabled selected={Motif == ''}>Veuillez sélectionner le motif</option>
                                    {MotifList?.length > 0 && MotifList?.map((item, i) => (
                                        <option selected={Motif == item} value={item}>{item}</option>
                                    ))
                                    }
                                </select>
                                <div className='err-cart-sum'>{Showerrors && errors?.Motif !== '' ? errors?.Motif : ''}</div>
                            </div>

                                        <div className="col-md-12">
                                            <div className="form-floating">
                                                <textarea maxLength={6000} className="form-control" onChange={(e) => setShortdescription(e.target.value)} value={Shortdescription} placeholder="Motif de rejet" id="floatingTextarea2" style={{ height: '100px' }} />
                                                <label htmlFor="floatingTextarea2">Motif (Comment)</label>
                                                <div className='err-cart-sum'>{Showerrors && errors?.Shortdescription !== '' ? errors?.Shortdescription : ''}</div>
                                            </div>
                                        </div>


                                    </div> 
                                      </>: ''
                            }
                               
                               <button onClick={UpdateClientEtat} className="btn-etat-send mt-4">Modifier</button>
                            
                                {/* <div className='alert-form'>{Showerr && (Typeactnaissnce == "" ? (infoperssonnelle['msgerr15'][Lang]) : '')}</div> */}
                            </div>: ''
                            }
                </div>
                </div>

            </div>


        </div>
    )
}

export default VoirDemande